import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const proofModule = {
  state: {},
  mutations,
  actions,
  getters,
};

export default proofModule;
